import { Form, FormApi, Icon, reactive } from 'cdui-js';
import { saveUserInfo } from '../../../../../api/open-account';
import { SelectCountry } from '../../../components/SelectCountry';
import { showToast } from '../../../components/Toast';
import { UploadProof } from '../../open-progress/UploadProof';
import { OpenFormItem } from '../../open-progress/components/OpenFormItem';
import { lastVirtualStep, notifyAppContinueAddVirtual, virtualApplyState } from './store';
import { DiFiInput } from '../../../../../components/DiFi/DiFiInput';
import { DiFiTooltip } from '../../../../../components/DiFi/DiFiTooltip';
import i18n from '../../../../../i18n';

import { consoleLog } from '../../../../../lib/utils';
import { addAccountBarPadBottom, addAccountContentReserve } from '../safeAreaBar';

const AddressInfo = () => {
  let formApi: FormApi = null;
  const state = reactive({ loading: false });

  return (
    <div>
      <div class="padding-x-L padding-y" style={{ 'margin-bottom': `${addAccountContentReserve(140)}px` }}>
        <div class="font-s-L font-bold color-D margin-b-L">{i18n.AddAccount.AddressTitle}</div>

        <Form
          data={virtualApplyState.addressForm}
          align="top"
          rules={{}}
          api={(api) => {
            formApi = api;
          }}
        >
          <OpenFormItem label={i18n.AddAccount.ResideCountry} field="country" required>
            <SelectCountry
              value={virtualApplyState.addressForm.country}
              change={(e) => (virtualApplyState.addressForm.country = e)}
            />
          </OpenFormItem>

          <OpenFormItem label={i18n.AddAccount.ResideAddress} field="address" required>
            <div>
              <DiFiInput
                shellClass="f-input-2"
                inputKind="text"
                maxLength={50}
                placeholder={i18n.AddAccount.AddressPlaceholder}
                value={virtualApplyState.addressForm.address}
                onUpdateValue={(v) => (virtualApplyState.addressForm.address = v)}
              />
            </div>
          </OpenFormItem>

          <OpenFormItem label={i18n.AddAccount.HomePhone} field="phone" required>
            <div>
              <DiFiInput
                shellClass="f-input-2"
                type="tel"
                inputKind="tel"
                maxLength={25}
                placeholder={i18n.AddAccount.HomePhonePlaceholder}
                value={virtualApplyState.addressForm.phone}
                onUpdateValue={(v) => (virtualApplyState.addressForm.phone = v)}
              />
            </div>
          </OpenFormItem>

          <OpenFormItem label={i18n.AddAccount.Email} field="email" required>
            <div>
              <DiFiInput
                shellClass="f-input-2"
                type="email"
                inputKind="email"
                maxLength={100}
                placeholder={i18n.AddAccount.EmailPlaceholder}
                value={virtualApplyState.addressForm.email}
                onUpdateValue={(v) => (virtualApplyState.addressForm.email = v)}
              />
            </div>
          </OpenFormItem>

          <div>
            <div class="font-s color-D flex align-center gap-4px margin-t-XL margin-b-XS">
              {i18n.OpenProgress.Info.Address.UploadProof}
              <DiFiTooltip
                content={i18n.OpenProgress.Info.Address.UploadProofTip}
                placement="top"
                autoFlip={false}
                ellipsis={false}
                style={{ width: 'auto', display: 'inline-flex', 'flex-shrink': 0 }}
              >
                <Icon name="common-info-empty" class="icon-c" />
              </DiFiTooltip>
            </div>

            <UploadProof
              useFor="address_prove"
              busId={virtualApplyState.busId}
              maxCount={5}
              imgs={virtualApplyState.addressProveUrls}
              change={({ url, action }) => {
                if (action === 'remove') {
                  virtualApplyState.addressProveUrls = virtualApplyState.addressProveUrls.filter(
                    (p) => p !== url,
                  );
                  return;
                }
                if (url) virtualApplyState.addressProveUrls = [...virtualApplyState.addressProveUrls, url];
              }}
            />
          </div>
        </Form>

        <div class="bg-c-XD round padding-L margin-t-S color-D">
          <div class="flex justify-space-between margin-b-L font-s-S">
            <div>{i18n.AddAccount.UploadExample}</div>
          </div>
          <img class="margin-b-L width-100" src="/images/upload-exp.svg" />
          <div class="font-s-XS">
            <div>{i18n.OpenProgress.Info.Address.Guide1}</div>
            <div>{i18n.OpenProgress.Info.Address.Guide2}</div>
            <div>{i18n.OpenProgress.Info.Address.Guide3}</div>
          </div>
        </div>
      </div>

      <div
        class="fixed position-b position-l width-100 bg-c padding-x-L flex gap-8px"
        style={{
          'padding-top': '12px',
          'padding-bottom': `${addAccountBarPadBottom(16)}px`,
          'z-index': 150,
        }}
      >
        <button
          class="default-btn btn-rounded"
          style={{ flex: 1 }}
          onclick={() => lastVirtualStep()}
          disabled={state.loading}
        >
          {i18n.OpenProgress.Common.Prev}
        </button>
        <button
          class="confirm-btn btn-rounded"
          style={{ flex: 2 }}
          onclick={async () => {
            if (state.loading) return;
            const valid = await formApi?.validate();
            if (!valid) return;
            if (!virtualApplyState.addressProveUrls.length) {
              showToast(i18n.AddAccount.ToastUploadAddress);
              return;
            }

            state.loading = true;
            try {
              const data = JSON.parse(JSON.stringify(virtualApplyState.addressForm));

              consoleLog(data, 'xxxxxxx0000------');
              // 仅更新地址信息，不改动大陆用户的 identity_type
              await saveUserInfo({ ...data });
              notifyAppContinueAddVirtual({ isMainlandIdentity: true, overseasIdentityDone: true });
            } catch (e) {
              showToast(e);
            } finally {
              state.loading = false;
            }
          }}
          disabled={state.loading}
        >
          {state.loading ? i18n.AddAccount.Submitting : i18n.OpenProgress.Common.Next}
        </button>
      </div>
    </div>
  );
};

export default AddressInfo;
